import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'
import { z } from 'zod'

export interface UseCloneVnetExtensionResult {
  form: UseFormReturn<CloneVnetExtensionForm>
  enabled: boolean
  setEnabled: (enabled: boolean) => void
  srcContainerId: string | null
}

export function useCloneVnetExtension(): UseCloneVnetExtensionResult {
  const [enabled, setEnabled] = useState(false)

  const form = useForm<CloneVnetExtensionForm>({
    resolver: zodResolver(cloneVnetExtensionSchema),
    defaultValues: {
      vnetUrl: '',
    },
    mode: 'onChange',
  })
  const { vnetUrl } = form.watch()
  const inputValid = form.formState.isValid

  return {
    form,
    enabled,
    setEnabled,
    srcContainerId: inputValid ? (vnetUrl.split('/').pop() ?? null) : null,
  }
}

const cloneVnetExtensionSchema = z
  .object({
    vnetUrl: z.string().url(),
  })
  .refine(
    (data) => {
      return data.vnetUrl.startsWith('https://dashboard.tenderly.co/')
    },
    {
      message: 'Enter valid URL starting with https://dashboard.tenderly.co/',
      path: ['vnetUrl'],
    },
  )

type CloneVnetExtensionForm = z.infer<typeof cloneVnetExtensionSchema>
